class MetaGeolocation {
  '2gis' = {
    address_name: null,
    full_name: null,
    id: null,
    name: null,
    point: null,
    purpose_name: null,
    search_attributes: null,
    subtype: null,
    type: null
  }
}

export default class Geolocation {
  address = ''
  lat = 0
  lon = 0
  displayAddress = ''
  meta = new MetaGeolocation()

  constructor (newData = null) {
    // populate new data
    if (newData) {
      for (const field in this) {
        this[field] = newData[field]
      }
    }
  }
}
